import { Component, OnInit } from '@angular/core';
import { DependentModel } from '../../models/dependent.model';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { CompanyModel } from '../../models/company.model';
import { Router, ActivatedRoute } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { CompanyService } from '../../services/company.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { ImageService } from '../../services/image.service';
import { MaskHelper } from '../../helpers/mask';
import { Form } from '../../services/form';

@Component({
  selector: 'app-register-dependent',
  templateUrl: './register-dependent.component.html',
  styleUrls: ['./register-dependent.component.less']
})
export class RegisterDependentComponent extends Form implements OnInit {

  dependent: DependentModel = new DependentModel();
  companies: Array<InputSelectModel> = new Array<InputSelectModel>();
  dependentCompany: CompanyModel;

  constructor(private router: Router, private route: ActivatedRoute, private dependentService: DependentService,
    private companyService: CompanyService, private notificationService: NotificationService, private imageService: ImageService) {
    super();
  }

  ngOnInit() {
    this.companyService.getAll()
    .then((companies: CompanyModel[]) => {

      const companiesWhoAcceptMeepCard = this.getCompaniesWhoAcceptMeepCard(companies);

      companiesWhoAcceptMeepCard.forEach((company: CompanyModel) => {
        this.companies.push({ title: company.name, value: company });
      });
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }

  private getCompaniesWhoAcceptMeepCard(companies: Array<CompanyModel>): Array<CompanyModel> {
    return companies.filter((company) => {
      if (company.isMeepCardAccepted) {
        return company;
      }
    });
  }

  registerDependent() {
    if (this.dependentCompany && this.dependentCompany.requireNumberOnAssociate === 3) {
      this.dependent.cardNumber = null;
    }
    if (this.getFormStatus()) {
      this.dependent.company = this.dependentCompany;
      this.dependent = MaskHelper.removeDependentMask(this.dependent);

      this.notificationService.showQuestionNotification
        ('Caso não tenha informado o número do cartão só será possível comprar nos terminais Meep via apelido. Deseja continuar?')
      .then(result => {
        if (result.value) {
          this.dependentService.save(this.dependent)
          .then(() => {
            this.notificationService.showSuccessNotification('Pronto! Não se esqueça de conferir a senha do cartão.')
              .then(() => {
                this.router.navigate([`general/cartoesDependentes`]);
              });
          })
          .catch((err) => {
            this.notificationService.showAlertNotification(err.message);
          });
        }
      });

    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }

  }
  
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/register-dependent/register-dependent.component.ts